import { warehouseClient } from "@/infrastructure/http/warehouseClient";

export interface ConversionFactorResult {
  factor: number | null;
  exists: boolean;
}

// Simple in-memory cache for the session
const cache = new Map<string, ConversionFactorResult>();

function cacheKey(fromUnitId: string, toUnitId: string, productId?: string): string {
  return `${fromUnitId}:${toUnitId}:${productId ?? ""}`;
}

export async function getConversionFactor(
  fromUnitId: string,
  toUnitId: string,
  productId?: string
): Promise<ConversionFactorResult> {
  const key = cacheKey(fromUnitId, toUnitId, productId);
  if (cache.has(key)) return cache.get(key)!;

  const params = new URLSearchParams({ fromUnitId, toUnitId });
  if (productId) params.set("productId", productId);

  const response = await warehouseClient.get<{ data: ConversionFactorResult }>(
    `/unit-conversion/factor?${params.toString()}`
  );

  const result: ConversionFactorResult = response.data?.data ?? { factor: null, exists: false };
  cache.set(key, result);
  return result;
}

export function clearConversionCache(): void {
  cache.clear();
}
